import { formatQuantity } from "@/lib/quantity-format";
import type { ReportInput } from "@/types/production-report.types";

// Spec 083 (T078) — a DIVERGÊNCIA entre o que esta etapa consumiu e o que a anterior entregou.
//
// ⚠️ EXIBE SEM JULGAR (FR-053). Sem limiar, sem cor de alarme, sem fila. O texto explica o SINAL,
// que é a única coisa que o gestor erra ao ler: sobra vira estoque entre etapas, falta vira consumo
// de estoque. Nenhuma das duas é erro, e pintar de vermelho afirmaria que uma delas é.

interface Props {
  input: ReportInput;
  unit: string;
}

const pct = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 1 });

export function InputDivergence({ input, unit }: Props) {
  if (input.upstreamDeclared === null || input.divergence === null) return null;

  const sobra = input.divergence < 0;
  return (
    <p className="text-[11px] text-text-secondary">
      A etapa anterior declarou {formatQuantity(input.upstreamDeclared)} {unit}.{" "}
      {input.divergence === 0 ? (
        "Os dois números batem."
      ) : (
        <>
          Diferença de {formatQuantity(Math.abs(input.divergence))} {unit}
          {input.divergencePct !== null ? ` (${pct.format(Math.abs(input.divergencePct))}%)` : ""}:{" "}
          {sobra
            ? "sobrou, e a sobra fica como estoque entre as etapas"
            : "faltou, e a falta veio de estoque"}
          .
        </>
      )}
    </p>
  );
}
